"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultComboBoxStandardSelect = void 0;
exports.createComboboxPropertySelector = createComboboxPropertySelector;
const react_1 = __importDefault(require("react"));
const property_1 = require("@promaster-sdk/property");
const combo_box_standard_select_1 = require("./combo-box-standard-select");
const combo_box_standard_option_1 = require("./combo-box-standard-option");
const image_dropdown_selector_1 = require("./image-dropdown-selector");
// function standardSelectStyles(
//   props: ComboBoxStandardSelectProps
// ): Array<StyledComponents.InterpolationValue> {
//   if (!props.isSelectedItemValid && props.locked) {
//     return StyledComponents.css`
//       background: lightgray;
//       color: red;
//       border: none;
//     `;
//   } else if (!props.isSelectedItemValid) {
//     return StyledComponents.css`color: red;`;
//   } else if (props.locked) {
//     return StyledComponents.css`
//       background: lightgray;
//       color: darkgray;
//       border: none;
//     `;
//   }
//   return StyledComponents.css``;
// }
function standardSelectStyles(props) {
    if (!props.isSelectedItemValid && props.locked) {
        return {
            background: "lightgray",
            color: "red",
            border: "none"
        };
    }
    else if (!props.isSelectedItemValid) {
        return { color: "red" };
    }
    else if (props.locked) {
        return {
            background: "lightgray",
            color: "darkgray",
            border: "none"
        };
    }
    return {};
}
const defaultComboBoxStandardOption = (0, combo_box_standard_option_1.createComboBoxStandardOption)({});
const defaultImageDropdownSelector = (0, image_dropdown_selector_1.createImageDropdownSelector)({});
const defaultComboBoxStandardSelect = (props) => (react_1.default.createElement(combo_box_standard_select_1.ComboBoxStandardSelect, Object.assign({}, props, { style: Object.assign({ color: "black", height: "30px", border: "1px solid #b4b4b4", borderRadius: "3px", font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif", outline: "rgb(131, 131, 131) none 0px", padding: "1px 30px 0px 10px" }, standardSelectStyles(props)) })));
exports.defaultComboBoxStandardSelect = defaultComboBoxStandardSelect;
function createComboboxPropertySelector({ ComboBoxStandardOption = defaultComboBoxStandardOption, ComboBoxStandardSelect = exports.defaultComboBoxStandardSelect, ComboBoxImageDropdownSelector = defaultImageDropdownSelector }) {
    return function ComboboxPropertySelector({ sortValidFirst, propertyName, propertyValueSet, valueItems, showCodes, onValueChange, filterPrettyPrint, readOnly, locked, comparer }) {
        const value = property_1.PropertyValueSet.getInteger(propertyName, propertyValueSet);
        const safeComparer = comparer || property_1.PropertyValue.defaultComparer;
        if (!valueItems) {
            valueItems = [];
        }
        const selectedValueItemOrUndefined = valueItems.find(item => (item.value && property_1.PropertyValue.getInteger(item.value)) === value);
        let selectedValueItem;
        if (!selectedValueItemOrUndefined) {
            selectedValueItem = {
                value: undefined,
                sortNo: -1,
                text: value === undefined || value === null ? "" : value.toString(),
                validationFilter: property_1.PropertyFilter.Empty
            };
            // Add value items for selected value, even tough it does not really exist, but we need to show it in the combobox
            // valueItems.unshift(selectedValueItem);
            valueItems = [
                selectedValueItem,
                ...valueItems
            ];
        }
        else {
            selectedValueItem = selectedValueItemOrUndefined;
        }
        // Convert value items to options
        const options = valueItems
            .map(valueItem => {
            const isItemValid = _isValueItemValid(propertyName, propertyValueSet, valueItem, safeComparer);
            return {
                value: _getItemValue(valueItem),
                label: _getItemLabel(valueItem, showCodes),
                isItemValid: isItemValid,
                image: valueItem.image,
                sortNo: valueItem.sortNo,
                toolTip: isItemValid
                    ? ""
                    : _getItemInvalidMessage(valueItem, filterPrettyPrint)
            };
        })
            .sort((a, b) => {
            if (sortValidFirst) {
                if (a.isItemValid && !b.isItemValid) {
                    return -1;
                }
                if (!a.isItemValid && b.isItemValid) {
                    return 1;
                }
            }
            if (a.sortNo < b.sortNo) {
                return -1;
            }
            if (a.sortNo > b.sortNo) {
                return 1;
            }
            return 0;
        });
        const selectedOption = options.find(option => option.value === _getItemValue(selectedValueItem));
        if (!selectedOption) {
            throw new Error("Could not find..");
        }
        if (valueItems.some(i => i.image !== undefined)) {
            const dropdownOptions = options.map(option => ({
                value: option.value,
                label: (option.isItemValid ? "" : "✘ ") + option.label,
                tooltip: option.toolTip,
                isItemValid: option.isItemValid,
                imageUrl: option.image
            }));
            return (react_1.default.createElement(ComboBoxImageDropdownSelector, { isSelectedItemValid: selectedOption.isItemValid, locked: locked, value: selectedOption.value, options: dropdownOptions, onChange: e => _doOnChange(e, onValueChange) }));
        }
        return (react_1.default.createElement(ComboBoxStandardSelect, { isSelectedItemValid: selectedOption.isItemValid, locked: locked, disabled: readOnly || locked, value: selectedOption.value, title: selectedOption.toolTip, onChange: event => _doOnChange(event.currentTarget.value, onValueChange) }, options.map(option => (react_1.default.createElement(ComboBoxStandardOption, { key: option.value, toolTip: option.toolTip, isItemValid: option.isItemValid, label: option.label, value: option.value })))));
    };
}
function _getItemLabel(valueItem, showCodes) {
    if (valueItem.value === undefined || valueItem.value === null) {
        return "";
    }
    return (valueItem.text +
        (showCodes ? ` (${property_1.PropertyValue.toString(valueItem.value)}) ` : ""));
}
function _doOnChange(newValue, onValueChange) {
    if (newValue === undefined || newValue === null) {
        onValueChange(undefined);
    }
    else {
        onValueChange(property_1.PropertyValue.create("integer", parseInt(newValue, 10)));
    }
}
function _getItemValue(valueItem) {
    if (valueItem.value === undefined || valueItem.value === null) {
        return "";
    }
    return property_1.PropertyValue.toString(valueItem.value);
}
function _getItemInvalidMessage(valueItem, filterPrettyPrint) {
    return filterPrettyPrint(valueItem.validationFilter);
}
function _isValueItemValid(propertyName, propertyValueSet, valueItem, comparer) {
    if (valueItem.value === undefined || valueItem.value === null) {
        return true;
    }
    const pvsToCheck = property_1.PropertyValueSet.set(propertyName, valueItem.value, propertyValueSet);
    if (!valueItem.validationFilter) {
        return true;
    }
    return property_1.PropertyFilter.isValid(pvsToCheck, valueItem.validationFilter, comparer);
}
//# sourceMappingURL=combobox-property-selector.js.map